import React from "react";
import "./Styles/LoadingSpinner.css";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="app-loading-spinner__container">
      <div className="app-loading-spinner__circle"></div>
    </div>
  );
};

export default LoadingSpinner;
